import { ErrorResponse, FgStatusEnum, JobCompletedEnum, OperationTypeEnum } from '@gtpl/shared-models/common-models';
import { CommonResponse, PlantIdRequest, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { AllSoakingResponseModel, assignSoakingForFreezingResponse, JobCompletedStatusDto, LotCodeDropDown, LotNumberRequest, SoakingDto,FreezingDto, AllFreezingResponseModel, FreezingGetDto } from '@gtpl/shared-models/production-management';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import appSettings from 'apps/services/config';
import { getManager, Raw, Repository } from 'typeorm';
import { WorkStations } from '../workstations/workstations.entity';
import { ProductionInventory } from './entities/production-inventory.entity';
import { ProductionLog } from './entities/production-log.entity';
import { ProductionInventoryRepository } from './repositories/production-inventory.repository';
import { ProductionLogRepository } from './repositories/production-log.repository';
@Injectable()
export class FreezingService {

    constructor(
        @InjectRepository(ProductionLogRepository)
        private repository: ProductionLogRepository,
        private prodInvRepo: ProductionInventoryRepository,
        private saleOrderService: SaleOrderService,
        private unitCodesService: UnitcodeService,

    ) { }


    async getAssignForFreezingDataa(plantId: number){
        try {
            // const lotNo = new LotNumberRequest(plantId, OperationTypeEnum.FREEZING)
            // const lotNoInfo: LotCodeDropDown[] = await this.prodInvRepo.getLotNumbers(lotNo);

            // const sublots:string[]=[]
            // for(const subLotInfo  of lotNoInfo){
            //     sublots.push(subLotInfo.subLotNumber)
            // }
            
            // if (lotNoInfo && lotNoInfo.length) {
            // if(sublots && sublots.length){
            const freezingInfo: ProductionLog[] = await this.repository.getAllFreezingInfo(plantId)
            console.log(freezingInfo)
            if(freezingInfo && freezingInfo.length) {
                const freezingDetails: SoakingDto[] = [];
                for (const freezingData of freezingInfo) {
                    console.log(freezingData.saleOrderItemId);
                    const poNo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({saleOrderId:freezingData.saleOrderId})
                    const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({saleOrderItemId:freezingData.saleOrderItemId})
                    console.log(soItemInfo,'soakinginfoooo');
                    freezingDetails.push(new SoakingDto(freezingData.productionLogId, freezingData.jobNumber, freezingData.lotNumber, freezingData.workStationType, freezingData.saleOrderId,soItemInfo.data.saleOrderNo, soItemInfo.data.variantCode, soItemInfo.data.soakingStyle, soItemInfo.data.soakingTime, freezingData.inputQuantity, freezingData.jobStatus, freezingData.assignFreezing,freezingData.shift,freezingData.assignedTime, freezingData.plantId,  freezingData.createdUser, freezingData.workstation.workstationId,freezingData.workStationType, freezingData.saleOrderItemId,freezingData.inputGrade,freezingData.outputBoxes,freezingData.operationType,freezingData.inputBoxes,freezingData.subLotNumber,freezingData.subPlantId,poNo.poNumber))
                    console.log("******************");
                }
                console.log(freezingDetails);
                return new AllSoakingResponseModel(true, 1111, 'Freezing Data from Log is Retrieved Successfully', freezingDetails)
            } else {
                  throw new ErrorResponse(99999, 'No Data Found');
            }
    //     } else {
    //         throw new ErrorResponse(99999, 'No Data Found');
    //     }
    // } else {
    //         throw new ErrorResponse(99999, 'No Data Found');
    //     }
        } catch (error) {
            return error
        }
    }

    async getAssignForFreezingData(plantId: number):Promise<CommonResponse>{
        try{
            const manager = getManager();
            let query ;
            const plantname='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
            const result =await manager.query(plantname);
            console.log(result[0].plant_type)
            query ='select pl.input_quantity as physicalQuantity,pl.input_grade as inpuGrade,pl.lot_number as lotNumber,sk.variant_code as variantCode,si.soaking_time as soakingTime,si.soaking_style as soakingStyle,soi.po_number as poNumber,so.sale_order_no as saleOrderNo,pl.production_log_id as productionLogId,pl.job_number as jobNumber,pl.workstation_type as workStationType,pl.sale_order_id as saleOrderId,pl.job_status as jobStatus,pl.assign_freezing as assignFreezing,pl.shift as shift,date(pl.assigned_time) as assignedTime,pl.plant_id plantId,pl.created_user as createdUser,pl.workstation as workstationId,pl.workstation_type as workStationType,pl.sale_order_item_id as saleOrderItemId,pl.input_grade as inpuGrade,pl.op_boxes as outputBoxes,pl.operation as operationType,pl.ip_boxes as inputBoxes,pl.sub_lot_number as subLotNumber,pl.sub_plant_id as subPlantId,pl.input_quantity as inputQuantity,concat(pl.lot_number,if(gi.remarks is not null,"-",""),if(gi.remarks is not null,gi.remarks,"")) as lotandplantLot,gi.remarks as plantLotNumber from '+appSettings.production_db+'.production_log pl left join '+appSettings.sales_db+'.sale_order so on so.sale_order_id = pl.sale_order_id left join '+appSettings.sales_db+'.so_invoice_details soi on soi.sale_order_id = pl.sale_order_id left join '+appSettings.sales_db+'.sale_order_items si on si.sale_order_item_id=pl.sale_order_item_id  left join '+appSettings.masters_db+'.sku_codes sk on sk.sku_code_id = si.varient_id left join '+appSettings.rm_procure_db+'.grn_items gi on gi.lot_number=pl.lot_number where pl.operation ="'+OperationTypeEnum.FREEZING+'" '

            if(result[0].plant_type == UnitTypeEnum.SUB_PLANT){
             query = query + ' and sub_plant_id ='+plantId+''
            }else{
                query = query + ' and plant_id ='+plantId+' and sub_plant_id=0'
            }
            const freezingdata = await manager.query(query)
            if(freezingdata.length >0){
                return new CommonResponse(true,1000,'data retrived sucessfully',freezingdata)
            }else{
                return new CommonResponse(false,1000,'no data found')

            }
            
        }catch(err){
            return err
        }
    }

    async getAssignForFreezingInvData(plantId: number):Promise<CommonResponse>{
        try {
            const manager = getManager();
            let query 
            const plantname='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
            const result =await manager.query(plantname);
            console.log(result[0].plant_type)
            query =` SELECT sd.po_number as poNumber,sk.variant_code as variantCode,si.soaking_time as soakingTime,si.soaking_style as soakingStyle,p.prod_inv_id AS productionInventoryId, CONCAT(COALESCE(gi.lot_number, ''), '  ',COALESCE(gi.remarks, '') ) AS lotNumber,concat(p.lot_number,if(gi.remarks is not null,'-',''),if(gi.remarks is not null,gi.remarks,'')) as plantandlot,gi.remarks as plantlotNumber,
             p.sub_lot_number AS sub_lot_number, p.sale_order_id AS saleOrderId, p.sale_order_item_id AS saleOrderItemId, p.operation AS operation, p.next_operation AS nextOperation,p.plant_id AS plantId,p.created_user AS createdUser,p.status,p.physical_quantity AS physicalQuantity,p.issued_quantity as inputQuantity FROM `+appSettings.production_db+`.production_inventory p 
            left join `+appSettings.sales_db+`.sale_order_items si on si.sale_order_item_id=p.sale_order_item_id 
            left join `+appSettings.sales_db+`.so_invoice_details sd on sd.sale_order_id=p.sale_order_id 
            left join `+appSettings.masters_db+`.sku_codes sk on sk.sku_code_id=si.varient_id 
            left join `+appSettings.rm_procure_db+`.grn_items gi ON gi.lot_number = p.lot_number
            WHERE next_operation="FREEZING" AND physical_quantity - issued_quantity > 0`
            if(result[0].plant_type == UnitTypeEnum.SUB_PLANT){
             query =query +' and sub_plant_id='+plantId+' '
            }else{
             query = query +' and plant_id='+plantId+' and sub_plant_id=0'
            }
       
            console.log(plantId,'plantId')
            const data = await manager.query(query);

            // const freezingInfo: ProductionInventory[] = await this.prodInvRepo.getAllInventoryData( OperationTypeEnum.FREEZING,plantId)
            // console.log(freezingInfo)
            
            // if(freezingInfo && freezingInfo.length) {
            //     const freezingDetails: FreezingGetDto[] = [];
            //     for (const freezingData of freezingInfo) {
            //     console.log(freezingData.saleOrderItemId);
            //         const soItemInfo = await this.saleOrderService.getVarientInfoForSoItem({saleOrderItemId:freezingData.saleOrderItemId})
            //         console.log(soItemInfo);
            //         const poNo = await this.saleOrderService.getSaleOrderFewDetailsForSoId({saleOrderId:freezingData.saleOrderId})
            //         freezingDetails.push(new FreezingGetDto(freezingData.productionInventoryId, freezingData.lotNumber, freezingData.saleOrderId, soItemInfo.data.saleOrderNo, soItemInfo.data.variantCode, soItemInfo.data.soakingStyle, soItemInfo.data.soakingTime, freezingData.issuedQuantity, freezingData.plantId, freezingData.createdUser, freezingData.saleOrderItemId, freezingData.operation, freezingData.nextOperation, freezingData.status,freezingData.physicalQuantity,poNo.poNumber!=undefined?poNo.poNumber:""))
            //         console.log("******************");
            //     }
            //     console.log(freezingDetails);
            //     return new AllFreezingResponseModel(true, 1111, 'Freezing Data from Inventory is Retrieved Successfully', freezingDetails)
            if(data){
             return new CommonResponse(true,1000,'data retrieved sucessfully',data)
            }
            else {
                throw new CommonResponse(false,99999, 'No Data Found');
          }
            } catch(err){
                return err
            }
        }

    async assignSoakingForFreezing(soakingInfo: FreezingDto): Promise<assignSoakingForFreezingResponse> {
        const manager = new GenericTransactionManager();

        try{
        
            await manager.startTransaction();
            let columnName;
            const updateInv = await manager.getCustomRepository(ProductionInventoryRepository).update(
                { lotNumber: Raw((alias) => `sub_lot_number = '${soakingInfo.subLotNumber}'`),productionInventoryId:soakingInfo.productionInventoryId},
                { status: FgStatusEnum.IN_PROGRESS }
            );
            if(updateInv){
                const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(soakingInfo.plantId))
                let productionInventoryData
                if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
                    columnName ='subPlantId'
                    productionInventoryData = await this.prodInvRepo.findOne({ where: { lotNumber: soakingInfo.lotNumber, subLotNumber: soakingInfo.subLotNumber, saleOrderId: soakingInfo.saleOrderId, saleOrderItemId: soakingInfo.saleOrderItemId, operation: OperationTypeEnum.FREEZING, subPlantId: soakingInfo.plantId } });
                }else{
                columnName = 'plantId'
                    productionInventoryData = await this.prodInvRepo.findOne({ where: { lotNumber: soakingInfo.lotNumber, subLotNumber: soakingInfo.subLotNumber, saleOrderId: soakingInfo.saleOrderId, saleOrderItemId: soakingInfo.saleOrderItemId, operation: OperationTypeEnum.FREEZING, plantId: soakingInfo.plantId,subPlantId:0 } });
                }
      
        let prodInvResponse;
            soakingInfo.subLotNumber = soakingInfo.subLotNumber
            soakingInfo.operation = OperationTypeEnum.FREEZING
            soakingInfo.wipQuantity = soakingInfo.physicalQuantity;
            soakingInfo.ipBoxes = soakingInfo.boxes;
            let productioninvId
            if (productionInventoryData) {
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryQuantity(soakingInfo,columnName);
                productioninvId = productionInventoryData.productionInventoryId
            } else {
                const prodInv = new ProductionInventory();
                prodInv.lotNumber = soakingInfo.lotNumber;
                prodInv.createdUser = soakingInfo.createdUser;
                prodInv.subLotNumber = soakingInfo.subLotNumber;
                prodInv.saleOrderId = soakingInfo.saleOrderId;
                prodInv.saleOrderItemId = soakingInfo.saleOrderItemId;
                prodInv.operation = OperationTypeEnum.FREEZING;
                prodInv.nextOperation = OperationTypeEnum.PACKING;
                // prodInv.physicalQuantity = soakingInfo.physicalQuantity;
                prodInv.wipQuantity=soakingInfo.physicalQuantity
                prodInv.inputGrade = soakingInfo.inputGrade;
                prodInv.boxes = soakingInfo.boxes;
                prodInv.plantId = soakingInfo.plantId;
                if (soakingInfo.subPlantId) {
                    prodInv.subPlantId = soakingInfo.subPlantId;
                }
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
                productioninvId = prodInvResponse.productionInventoryId

            }
        console.log("*******************************************");
        console.log(productionInventoryData);
        let flag: boolean = false;
        let updateLogStatus;
        if(productionInventoryData.inventoryType != "Product_Conversion"){
            updateLogStatus = await manager.getCustomRepository(ProductionLogRepository).update(
                { lotNumber: Raw((alias) => `lot_number = '${soakingInfo.lotNumber}'`),subLotNumber:Raw((alias) => `sub_lot_number = '${soakingInfo.subLotNumber}'`) },
                { assignFreezing: JobCompletedEnum.YES , jobStatus: JobCompletedEnum.YES}
            );
            if(updateLogStatus.affected>0){
                flag = true
            }
            else{
                flag = false
            }
        }
        else{
            flag = true
        }
        
        console.log(updateLogStatus);
        if (flag) {
            const prodLog =  new ProductionLog();

            // job number generation 
            let today = new Date();
            let CurrentYear = today.getFullYear();
            let CurrentMonth = today.getMonth();
            let fromDate = 0;
            let toDate = 0;
            let totalRecords = await (await this.repository.find({where:{operationType:OperationTypeEnum.FREEZING}})).length;
                if (CurrentMonth < 4) {
                    fromDate = (CurrentYear-1);
                    toDate = (CurrentYear);
                } else {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                }

            totalRecords = totalRecords + 1;

            var refNo = totalRecords + "";
            while (refNo.length < 4) refNo = "0" + refNo;

            const freezingJobNo = "Freezing/" + (fromDate.toString().substr(-2))+"-"+(toDate.toString().substr(-2)) + "/" + refNo;

            prodLog.jobNumber = freezingJobNo; 
            prodLog.lotNumber = soakingInfo.lotNumber;
            prodLog.subLotNumber = soakingInfo.subLotNumber;
            prodLog.saleOrderId = soakingInfo.saleOrderId;
            prodLog.inputQuantity = soakingInfo.physicalQuantity;
            prodLog.assignFreezing = JobCompletedEnum.YES;
            prodLog.jobStatus = JobCompletedEnum.NO;
            prodLog.shift = soakingInfo.shift;
            prodLog.assignedTime = soakingInfo.assignedTime;
            prodLog.plantId = soakingInfo.plantId;
            prodLog.createdUser = soakingInfo.createdUser;
            prodLog.workstation = new WorkStations();
            prodLog.workstation.workstationId = soakingInfo.workstation;
            prodLog.saleOrderItemId = soakingInfo.saleOrderItemId;
            prodLog.operationType = OperationTypeEnum.FREEZING;
            prodLog.inputGrade = soakingInfo.inputGrade;
            prodLog.inputBoxes = soakingInfo.boxes;
            prodLog.prodInvId = productioninvId;
            prodLog.assignedUser = soakingInfo.createdUser;
            const saveProdLog = await manager.getCustomRepository(ProductionLogRepository).save(prodLog);

            const updatePrevOPQty = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryIssuedQuantity(soakingInfo.lotNumber,soakingInfo.subLotNumber,soakingInfo.saleOrderId,soakingInfo.saleOrderItemId,soakingInfo.productionInventoryId,soakingInfo.plantId,soakingInfo.physicalQuantity);
            if (saveProdLog && prodInvResponse && updatePrevOPQty) {
                await manager.completeTransaction();
                return new assignSoakingForFreezingResponse(true, 5555, 'Assigned to Freezing', true)
            } else {
                await manager.releaseTransaction();
                return new assignSoakingForFreezingResponse(false, 9999, 'some thing went wrong', false)
            }
        } else {
            await manager.releaseTransaction();
            throw new ErrorResponse(9999, 'Failed to update');
        }
        }
        else {
            await manager.releaseTransaction();
            throw new ErrorResponse(9999, 'Failed to update');
        }
    } catch (error) {
        console.log(error)
        console.log('throw block executes')
        await manager.releaseTransaction();
        throw error;
    }
    }

    async jobCompletedStatus(soakingInfo: SoakingDto): Promise<assignSoakingForFreezingResponse> {
        // const manager = new GenericTransactionManager();
        const updateStatus = await this.repository.update(
            { lotNumber: Raw((alias) => `lot_number = '${soakingInfo.lotNumber}'`) },
            { jobStatus: JobCompletedEnum.YES }
        );
        const updatePhySicalQuantityandWipQnty = await this.prodInvRepo.update({lotNumber:Raw((alias) => `lot_number = '${soakingInfo.lotNumber}'`),operation:OperationTypeEnum.FREEZING},{physicalQuantity: () =>`physical_quantity+${soakingInfo.physicalQuantity}`,wipQuantity :() => `wip_quantity-${soakingInfo.physicalQuantity}`})

        if (updateStatus && updatePhySicalQuantityandWipQnty) {
           
            // const prodLog =  new ProductionLog();
            // prodLog.jobNumber = 'freezing001';
            // prodLog.lotNumber = soakingInfo.lotNumber;
            // prodLog.subLotNumber = soakingInfo.lotNumber;
            // prodLog.saleOrderId = soakingInfo.saleOrderId;
            // prodLog.inputQuantity = soakingInfo.physicalQuantity;
            // prodLog.assignFreezing = soakingInfo.assignFreezing;
            // prodLog.jobStatus = soakingInfo.jobStatus;
            // prodLog.shift = soakingInfo.shift;
            // prodLog.assignedTime = soakingInfo.assignedTime;
            // prodLog.plantId = soakingInfo.plantId;
            // prodLog.createdUser = soakingInfo.createdUser;
            // prodLog.workstation = new WorkStations();
            // prodLog.workstation.workstationId = soakingInfo.workstation;
            // prodLog.saleOrderItemId = soakingInfo.saleOrderItemId;
            // prodLog.operationType = OperationTypeEnum.FREEZING;
            // prodLog.assignedUser = soakingInfo.createdUser;
            // prodLog.createdUser = soakingInfo.createdUser;
            // prodLog.inputBoxes = soakingInfo.boxes;
            // prodLog.shift = soakingInfo.shift;
            // prodLog.inputGrade = soakingInfo.inputGrade;

            // const saveProdLog = await this.repository.save(prodLog);
            
            return new assignSoakingForFreezingResponse(true, 1111, 'Updated to completed');

        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }

}
